"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("../consts");
const dateToEpochSeconds_1 = __importDefault(require("./dateToEpochSeconds"));
function calculateCappedModuleDuration(timeStarted, timeFinished) {
    //It is possible for a student to change their time zone and have a study time difference
    //Here we take the absolute time difference to ensure it is always positive https://github.com/SenecaLabs/senecaWeb/pull/16969#issuecomment-2074934411
    const moduleStudyTime = Math.abs((0, dateToEpochSeconds_1.default)(timeFinished) - (0, dateToEpochSeconds_1.default)(timeStarted));
    return Math.min(moduleStudyTime, consts_1.MAX_MODULE_DURATION_SECONDS);
}
exports.default = calculateCappedModuleDuration;
